import { AdasBox, AdasTypography } from '@components/wrapper-components'
import { isAutoQuoteProduct } from '../../utils/productClass'

// Static reference for the calibration levels used in product names ("Level 3B", etc.).
// Deliberately carrier-neutral: State Farm and Allstate share these levels, so the legend
// is not labelled after either. Wording mirrors the backend calibration product seeds.
// Static text — not derived from the vehicle or the ADAS Intelligence scrub.
// Styled to match ProductContractBanner, which national agreement records show instead.
export const CALIBRATION_LEVELS = [
  { code: '1', text: 'Initialization' },
  { code: '2', text: 'Dynamic' },
  { code: '3a', text: 'Targeted Calibrations (All Other Makes)' },
  { code: '3b', text: 'Targeted Calibrations (Mercedes, Subaru)' },
  { code: '3c', text: 'Targeted Calibrations (Porsche, Audi, VW)' }
]

// CAR-4019 — levels are an Auto Quote concept: the Quote, Work Order and Invoice summaries show the
// legend only when a calibration or service line is an Auto Quote product. Store-only, service-only
// and national agreement records (which show ProductContractBanner instead) get no legend.
export const shouldShowLevelLegend = ({ packages = [], services = [], isServiceOnly, hasContract }) =>
  !isServiceOnly && !hasContract && [...packages, ...services].some(isAutoQuoteProduct)

export const CalibrationLevelLegend = () => (
  <AdasBox className='overflow-hidden mt-2 mb-4 rounded-[12px] border border-[#0A1628]/10 shadow-sm' data-testid='calibration-level-legend'>
    <AdasBox
      className='flex items-center gap-3.5 w-full py-[5px] px-5 text-[#fff]'
      style={{ background: 'linear-gradient(135deg, #172641 0%, #2B4064 100%)' }}
    >
      <AdasTypography variant='caption' fontWeight='700' className='uppercase leading-4 text-[11px] tracking-[0.08em] text-[#fff]'>
        ADAS Product Levels
      </AdasTypography>
    </AdasBox>
    <AdasBox className='flex flex-col pt-1 pb-1.5 bg-[#fff]'>
      {CALIBRATION_LEVELS.map(({ code, text }) => (
        <AdasBox key={code} className='flex items-baseline gap-3 py-px px-5'>
          <AdasTypography variant='subtitle2' className='shrink-0 w-[18px] text-[13px] leading-[18px] font-extrabold text-[#2B3E63]'>
            {code}
          </AdasTypography>
          <AdasTypography variant='subtitle2' className='text-[13px] leading-[18px] font-normal text-[#2E3D57]'>
            {text}
          </AdasTypography>
        </AdasBox>
      ))}
    </AdasBox>
  </AdasBox>
)
